module.exports = __webpack_public_path__ + "img/green.7fe5f729.png";